import { baseApi } from "api/BaseApi";
import {
  PaginatedResponse,
  PaginatedQuery,
} from "api/common/types/response.types";
import { PineFilters } from "features/memberPortal/products/PINE/components/ProductsInEvalTable/schemas/Pine.schema";

import { PaginatedEars } from "../ear/ear.types";
import { Product } from "../project/product/product.types";

const PRODUCT_BASE_QUERY = "v2/products";

type PaginatedProducts = PaginatedResponse<Product>;
type PaginatedProductsQuery = PaginatedQuery<PineFilters>;

const productApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    // LIST
    listProducts: build.query<PaginatedProducts, PaginatedProductsQuery>({
      query: (filters) => ({
        url: `${PRODUCT_BASE_QUERY}/`,
        params: filters,
      }),
      providesTags: ["PRODUCTS"],
    }),

    listProductEars: build.query<PaginatedEars, Record<string, any>>({
      query: ({ productId, params }) => ({
        url: `${PRODUCT_BASE_QUERY}/${productId}/ears/`,
        params: params,
      }),
      providesTags: ["EARS"],
    }),

    // DELETE
    deleteProduct: build.mutation<Product, number>({
      query: (id) => ({
        url: `${PRODUCT_BASE_QUERY}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["PRODUCTS"],
    }),
  }),

  overrideExisting: false,
});

export const {
  useListProductsQuery,
  useListProductEarsQuery,
  useDeleteProductMutation,
} = productApi;
